import {Injectable} from '@angular/core';
import * as Numeral from 'numeral';
import { LocalStorageService } from 'ng2-webstorage';
import { API } from '../constants/api.constants';
import { Http, Response } from '@angular/http';
import { SystemSetting } from '../../entities/system-setting/system-setting.model';
import { AuthServerProvider } from '../auth/auth-jwt.service';
import { Common } from '../common/common';

@Injectable()
export class SystemSettingStorageService {

    private resourceUrl = API.host + 'InvoicePortal/systemSettings';
    private resourceUrlCompany = API.host +'InvoicePortal/InvoicePortal-systemSettings'; 

    constructor(
        private http: Http,
        private $localStorage: LocalStorageService,
        private $authServerProvider: AuthServerProvider,
        private common: Common,
    ) {}

    getSystemSetting(): SystemSetting{
        // get SystemSetting lưu từ LocalStorage, nếu không có thì get từ DB 
        let jsonInfo: any = this.$authServerProvider.getInfo().systemSetting || {};

        if (!jsonInfo || Object.keys(jsonInfo).length === 0){
            this.getDBAndStoreSystemSetting(jsonInfo)
            // jsonInfo = this.$authServerProvider.getInfo().systemSetting
        }

        return jsonInfo;
    }

    observStoreSystemSetting(){
        return this.http.get(`${this.resourceUrl}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid request';
            }
            // console.log(res.json().data);
            this.storeSystemSetting(res.json().data);
            return res.json().data;
        });
    }

    private getDBAndStoreSystemSetting(output) {
        this.observStoreSystemSetting().subscribe(res => {
            this.common.deepCopyToExistedObj(res, output);
        });
    }

    private storeSystemSetting(systemSetting){
        var authInfo = this.$authServerProvider.getInfo();
        authInfo.systemSetting = systemSetting;

        this.$localStorage.store('authenticationInfo', JSON.stringify(authInfo));
    }

    // hóa đơn tra cứu trên portal có thể thuộc về nhiều công ty khác nhau, không store cho trường hợp này được
    getSystemSettingOneTime(companyID: number) {
        return this.http.get(`${this.resourceUrlCompany}/${companyID}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid request';
            }
            let data = res.json().data;
            if (data === null || data === undefined) {
                return new SystemSetting();
            }
            return data;
        });
    }
}
